import React, {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {useMediaQuery} from 'react-responsive';

import {gt} from 'app/utils/i18n';

import {ChatWidget} from './ChatWidget';

import {selectIsHidingChat, setChatHidden, toggleChat} from '../slice';

import type {RootState} from '../store/ChatAppStore';

export const ChatEnabler = () => {
  const dispatch = useDispatch();
  const url = window.SweetProcessVariables?.kburl;
  const kbId = window.SweetProcessVariables?.kbid;

  const isDesktop = useMediaQuery({query: '(min-width: 1224px)'});

  const isHidingChat: boolean = useSelector<RootState, boolean>((state) => {
    // hide chat until we have a URL we can look up in state to prevent flash.
    return url == null ? true : selectIsHidingChat(state, url);
  });

  useEffect(
    function () {
      if (!isDesktop && url) {
        dispatch(setChatHidden({url}));
      }
    },
    [isDesktop, url]
  );

  if (kbId == null || url == null) {
    return null;
  }

  return (
    <ChatWidget
      isHidingChat={isHidingChat}
      toggleChat={(url) => dispatch(toggleChat({url}))}
      url={url}
      objectId={kbId}
      contentType={'knowledgebase'}
      chatType="rag"
      placeholder={gt('Ask about the articles in this knowledge base!')}
    />
  );
};
